import React, { useMemo } from 'react';
import {
  Row, Col, Select,
  Space,
} from 'antd';
import PropTypes from 'prop-types';
import { getIdMap } from '../../../../helpers/helpers';

function TableCostcodePreload({
  configProps,
  updateConfig,
  costcodes,
  costcodesLoading,
  sections = [],
  hideTitle = false,
}) {
  const globalCostcodes = useMemo(() => (
    costcodes.filter((cc) => !cc.projectId)
  ), [costcodes]);

  const costcodeOptions = useMemo(() => (
    globalCostcodes.map((cc) => ({
      value: cc.id,
      label: `${cc.code} - ${cc.name}`,
      name: cc.name,
      code: cc.code,
    }))
  ), [globalCostcodes]);

  const costcodeOptionsMap = useMemo(() => getIdMap(costcodeOptions, 'value'), [costcodeOptions]);

  const costcodeDropdownOptions = sections.reduce((acc, section) => {
    const { fields = [], name: sectionName } = section;
    return acc.concat(
      fields?.reduce((fieldAcc, field) => {
        const {
          id: fieldId,
          selectedType,
          configProps: {
            dataType: fieldDataType,
            title: fieldTitle,
          } = {},
        } = field;
        if (selectedType !== 'dropdown') return fieldAcc;
        if (fieldDataType !== 'Costcodes') return fieldAcc;
        return fieldAcc.concat([{
          label: `${sectionName} - ${fieldTitle}`,
          value: fieldId,
        }]);
      }, []),
    );
  }, []);

  const updateValue = (key) => (value) => {
    updateConfig({ [key]: value });
  };

  const hasProject = configProps.preloadProject || configProps.preloadDropdown;

  return (
    <Space direction="vertical">
      <Row align="middle" gutter={10} style={{ marginLeft: hideTitle ? 0 : 10 }}>
        <Col>
          With Cost Code
        </Col>
        <Col>
          <Select
            options={costcodeOptions}
            loading={costcodesLoading}
            style={{ width: 500 }}
            optionFilterProp="label"
            allowClear
            showSearch
            placeholder="Select a Cost Code"
            value={configProps.preloadCostcode}
            disabled={configProps.preloadCostcodeDropdown || !hasProject}
            onChange={(value) => {
              const selectedCostcode = costcodeOptionsMap[value];
              updateConfig({
                preloadCostcode: value,
                preloadCostcodeName: selectedCostcode?.name,
                preloadCostcodeCode: selectedCostcode?.code,
              });
            }}
          />
        </Col>
      </Row>
      <Row align="middle" gutter={10} style={{ marginLeft: hideTitle ? 0 : 10 }}>
        <Col>
          Or Cost Code Dropdown
        </Col>
        <Col>
          <Select
            style={{ width: 500 }}
            options={costcodeDropdownOptions}
            optionFilterProp="label"
            allowClear
            showSearch
            placeholder="Select a Cost Code Dropdown Field"
            value={configProps.preloadCostcodeDropdown}
            disabled={configProps.preloadCostcode || !hasProject}
            onChange={updateValue('preloadCostcodeDropdown')}
          />
        </Col>
      </Row>
    </Space>
  );
}

/* eslint-disable react/forbid-prop-types */
TableCostcodePreload.propTypes = {
  configProps: PropTypes.object.isRequired,
  updateConfig: PropTypes.func.isRequired,
  costcodes: PropTypes.arrayOf(PropTypes.shape({})),
  costcodesLoading: PropTypes.bool,
  sections: PropTypes.array,
  hideTitle: PropTypes.bool,
};

TableCostcodePreload.defaultProps = {
  costcodes: [],
  costcodesLoading: false,
  sections: [],
  hideTitle: false,
};

export default TableCostcodePreload;
